module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC4SURBVHgB7djRCYMwFAXQa+kAbtCMkA1KN7GTlE5SN2i7gd0gI2SUvmcM/mn+8oL3QHwR8nER4UIAIiKiCjp9eO8HGVfY9gshjPmlW0K/0IZ7Dn+S5dAOlzcafJQVYV9AykpERCttzl7mQ5ZHfZM047PkoMXKv0n4ae+QNmcPW4rynJFqVH+TC+r7ytf+gIiISmlzOplv2Kj8LRGpVXXOzTnAfmjlkLLONHhEO2LeNHshRERERIfwB6G4KfX1MJWtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-icon.png
// module id = 1722
// module chunks = 1